import { useSyncExternalStore } from 'react';
import { CONSULTA_CELULAR, CONSULTA_DEITADO } from './layoutCelular';

/** Assina uma media query CSS. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(query).matches,
    () => false,
  );
}

/** Tela de celular: menos de 768 px de largura, ou celular deitado (pouca altura e toque). */
export function useIsMobile(): boolean {
  return useMediaQuery(CONSULTA_CELULAR);
}

/** Tela deitada (pouca altura): no celular, o trilho de camadas em duas colunas (ui/layoutCelular). */
export function useDeitado(): boolean {
  return useMediaQuery(CONSULTA_DEITADO);
}

/** Dispositivo com mouse (mostra coordenadas do cursor). */
export function useHasHover(): boolean {
  return useMediaQuery('(hover: hover) and (pointer: fine)');
}
